import { render } from "./SemesterForm.vue?vue&type=template&id=7a8e4b0b"
import script from "./SemesterForm.vue?vue&type=script&lang=js"
export * from "./SemesterForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__